import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ViewEncapsulation,
} from "@angular/core";
import { IconModel } from "./model/icon.model";
import { CommonModule } from "@angular/common";
import { MaterialModule } from "../../module/material.module";

@Component({
  selector: "rfc-icon",
  templateUrl: "./icon.component.html",
  styleUrls: ["./icon.component.scss"],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    CommonModule, 
    MaterialModule
  ]
})
export class IconComponent implements OnChanges {
  @Input() iconInput: IconModel;

  constructor() {}
  ngOnChanges(changes: SimpleChanges) {}
}
